angular.module('codebookService', ['ui.router', 'constants'])
.factory('codebookService', function($http, $q, $rootScope, myConfig) {

  var service = {};
  service.codebook = null;

	var _baseUrl = myConfig.apiUrl + 'codebook/'; //'http://127.0.0.1:8000/v1/codebook/';

  //var codebook = [];
  
  service.fetchCodebook = function() {
    var deffered = $q.defer();
    if ( service.codebook !== null ) {
      deffered.resolve( service.codebook );
    } else {
      var userToken = localStorage.getItem('userToken');
      var userId = $rootScope.user.id;
      $http({
        method: 'GET',
        url: _baseUrl + 'codebook',
        withCredentials: true,
      }).then(function(response){
        deffered.resolve(response.data);
        service.codebook = response.data;
      });      
    }
    return deffered.promise;
  }

  // get list of districts
  service.fetchOkresy = function(scheme) {
      var deferred = $q.defer();
      var userToken = localStorage.getItem('userToken');
      var additionalUrl = '';
      if (scheme) {
        var additionalUrl = '?where=Country is \'' + scheme + '\'';
      }      
      var url = myConfig.apiUrl + 'rings/vw_counties' + additionalUrl;
      $http({
        method: 'GET',
        url: url,
        withCredentials: true,
      }).then(function(response){
        deferred.resolve(response.data);
      })
      return deferred.promise;
    }

  // get list of districts
  service.fetchZeme = function() {
      var deferred = $q.defer();
      var userToken = localStorage.getItem('userToken');
      var additionalUrl = '';
      
      var url = myConfig.apiUrl + 'rings/vw_countries';
      $http({
        method: 'GET',
        url: url,
        withCredentials: true,
      }).then(function(response){
        deferred.resolve(response.data);
      })
      return deferred.promise;
    }

  return service;

});
